import { tv } from 'tailwind-variants';

const carouselNavigationStyles = tv({
    slots: {
        base: "iris:z-999",
        container: ``,
    },
    variants: {
        position: {
            over: {
                base: `
          iris:absolute 
          iris:top-1/2 
          iris:-translate-y-1/2 
          iris:transform`,
            },
            under: {
                base: "",
            },
        },
        direction: {
            left: {},
            right: {},
        },
        disabled: {
            true: `iris:pointer-events-none iris:cursor-not-allowed iris:opacity-50`,
            false: ``,
        },
    },
    compoundVariants: [
        {
            position: "over",
            direction: "left",
            class: `
        iris:left-0
        iris:ml-(--comp-space-padding-carousel-controls-all)
        `,
        },
        {
            position: "over",
            direction: "right",
            class: `
        iris:right-0
        iris:mr-(--comp-space-padding-carousel-controls-all)
      `,
        },
        {
            position: "under",
            direction: "left",
            class: `
     `,
        },
        {
            position: "under",
            direction: "right",
            class: `
      iris:ml-auto`,
        },
    ],
    defaultVariants: {
        position: "under",
    },
});

export { carouselNavigationStyles, carouselNavigationStyles as default };
